import Echo from 'laravel-echo';
require('pusher-js');

const Websockets = {
    namespaced: true,
    state: {
        socketConnection: false,
        userChannel: null,
        notificationsChannel: null,
        promise: null,
    },
    mutations: {
        SET_USER_CHANNEL(state, data) {
            state.userChannel = data;
        },
        SET_NOTIFICATIONS_CHANNEL(state, data) {
            state.notificationsChannel = data;
        },
        SET_SOCKET_CONNECTION(state, data) {
            state.socketConnection = data;
        },
        SET_PROMISE(state, data) {
            state.promise = data;
        },
    },
    getters: {
        userChannel: (state) => {
            return state.userChannel;
        },
        notificationsChannel: (state) => {
            return state.notificationsChannel;
        },
        promise: (state) => {
            return state.promise;
        },
    },
    actions: {
        initWebsocket({ commit, getters }) {
            if (!getters.promise) {
                let promise = new Promise((resolve) => {
                    if (!getters.socketConnection) {
                        axios.get(route('api.v1.websockets.config')).then((response) => {
                            let config = response.data;

                            let echo = new Echo({
                                broadcaster: 'pusher',
                                key: config.key,
                                wsHost: config.host === null ? window.location.hostname : config.host,
                                wsPort: config.port === null ? 6001 : config.port,
                                wssPort: config.port === null ? 6001 : config.port,
                                forceTLS: config.tls,
                                disableStats: !config.stats,
                                cluster: 'mt1',
                                namespace: '',
                            });

                            commit('SET_SOCKET_CONNECTION', echo);

                            resolve(echo);
                        });
                    } else {
                        resolve(getters.socketConnection);
                    }
                });

                commit('SET_PROMISE', promise);
            }

            return getters.promise;
        },

        initUserChannel({ commit, getters, dispatch }) {
            return new Promise((resolve) => {
                dispatch('initWebsocket').then((echo) => {
                    let channel = getters.userChannel;

                    if (!channel) {
                        let channel = echo.private('user.' + User.id);

                        channel.listen('pusher:subscription_succeeded', () => {
                            commit('SET_USER_CHANNEL', channel);
                            resolve(channel);

                            /*channel.listenForWhisper('whisper-name', (data) => {
                            });*/
                        });
                    } else {
                        resolve(getters.userChannel);
                    }
                });
            });
        },

        initNotificationsChannel({ commit, getters, dispatch }) {
            return new Promise((resolve) => {
                dispatch('initWebsocket').then((echo) => {
                    let channel = getters.notificationsChannel;

                    if (!channel) {
                        let channel = echo.private('notifications');

                        channel.listen('pusher:subscription_succeeded', () => {
                            commit('SET_NOTIFICATIONS_CHANNEL', channel);
                            resolve(channel);
                        });
                    } else {
                        resolve(getters.notificationsChannel);
                    }
                });
            });
        },
    },
};

export default Websockets;
